import React from 'react';
import { Package, MapPin } from 'lucide-react';
import { FracasIncident } from '../../types/fracas.types';

export const FracasCoreInfo: React.FC<{ incident: FracasIncident }> = ({ incident }) => {
    return (
        <>
            {/* Description */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-3">Problem Description</h3>
                <p className="text-gray-700 whitespace-pre-wrap">{incident.problemDescription}</p>
                {incident.complaintDescription && incident.complaintDescription !== incident.problemDescription && (
                    <div className="mt-4 pt-4 border-t border-gray-100">
                        <h4 className="text-sm font-semibold text-gray-700 mb-1">Customer Complaint</h4>
                        <p className="text-gray-600 text-sm whitespace-pre-wrap">{incident.complaintDescription}</p>
                    </div>
                )}
            </div>

            {/* Product & Component Info */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Product Information</h3>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <p className="text-sm text-gray-600">Product</p>
                        <p className="text-gray-900 font-medium flex items-center gap-2">
                            <Package className="w-4 h-4" />
                            {incident.productName}
                        </p>
                    </div>
                    {incident.partNumber && (
                        <div>
                            <p className="text-sm text-gray-600">Part Number</p>
                            <p className="text-gray-900 font-medium">{incident.partNumber}</p>
                        </div>
                    )}
                    <div>
                        <p className="text-sm text-gray-600">Failure Mode</p>
                        <p className="text-gray-900 font-medium">{incident.failureMode || 'N/A'}</p>
                    </div>
                    {incident.serialNumber && (
                        <div>
                            <p className="text-sm text-gray-600">Serial Number</p>
                            <p className="text-gray-900 font-medium">{incident.serialNumber}</p>
                        </div>
                    )}
                </div>
            </div>

            {/* Impact Analysis */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Impact Analysis</h3>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <p className="text-sm text-gray-600">Quantity Affected</p>
                        <p className="text-gray-900 font-medium text-2xl">{incident.quantityAffected}</p>
                    </div>
                    {incident.location && (
                        <div>
                            <p className="text-sm text-gray-600">Location</p>
                            <p className="text-gray-900 font-medium flex items-center gap-2">
                                <MapPin className="w-4 h-4" />
                                {incident.location}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
